import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import * as Services from '@shared/core/services';
import { ISubNavPage } from '@shared/core/components/subNav';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'shared-draw-bar-menu',
    templateUrl: './draw-bar-menu.shared.component.html',
    styleUrls: ['./draw-bar-menu.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DrawBarMenuComponent implements OnInit, OnDestroy {
    private _isOpen: boolean = false;

    @Input() public search: boolean = false;
    @Input() public registryId: string = 'locationDetails';
    @Input() public searchTerm: string;
    @Input() public pages!: ISubNavPage[];
    @Input() public activePageId!: number;
    @Input() public scroll: boolean = false;
    @Input() public handleDrawCollapse: boolean = true;
    @Input() public relativeTarget!: HTMLElement;
    @Input() public toggleIcon: string = 'burger-menu';
    @Input() public back: boolean = false;

    @Output() public onBackClick: EventEmitter<Event> = new EventEmitter();
    @Output() public onSearchToggle: EventEmitter<boolean> = new EventEmitter();
    @Output() public onPageClick: EventEmitter<ISubNavPage> = new EventEmitter();

    public hasScrolled$: Observable<boolean>;

    constructor(
        public drawCollapseService: Services.DrawCollapseService,
        public subNavService: Services.SubNavService,
    ) { }

    ngOnInit(): void {
        this.hasScrolled$ = this.drawCollapseService.drawProgress$
            .pipe(
                map(val => val < .5)
            );
    }

    ngOnDestroy(): void {
        this._bodyScrollLock(false);
    }

    private _bodyScrollLock(lock: boolean): void {
        if (lock) {
            document.body.style.height = '100vh';
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.height = null;
            document.body.style.overflow = null;
        }
    }

    public handleSearchToggle(isOpen: boolean): void {
        this._isOpen = isOpen;
        this.onSearchToggle.emit(this._isOpen);
        this._handleDrawCollapse();
    }

    private _handleDrawCollapse(): void {
        if (this.isMobile && this.handleDrawCollapse) {
            this._bodyScrollLock(this._isOpen === true);

            if (this._isOpen) {
                this.drawCollapseService.toggleDraw(false);

                setTimeout(() => {
                    this.subNavService.forceHeightUpdate();
                }, 500);
            } else {
                this.drawCollapseService.toggleDraw(true);
            }
        }
    }

    public handlePageClick($event: ISubNavPage): void {
        this.handleSearchToggle(false);
        this.onPageClick.emit($event);
    }

    public handleBackClick($event: Event): void {
        // this.controllers.routes.navigateToLocationsSearchView();
        this.onBackClick.emit($event);
    }

    public get isOpen(): boolean {
        return this._isOpen;
    }

    public get isMobile(): boolean {
        return window.innerWidth < 768;
    }

    public get activeId(): number {
        return this.activePageId;
    }

    public get delayScroll(): number {
        return 200;
    }
}
